import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { FileText, LayoutDashboard, Files, Settings, Ellipsis } from 'lucide-react'
import { useMutation } from 'convex/react'
import { useAuth } from '@workos-inc/authkit-react'
import { api } from '@convex/_generated/api'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { LogoutButton } from '@/components/logout-button'

export const Route = createFileRoute('/_layout/_app/')({
  component: WelcomePage,
  staticData: { title: '' },
})

function WelcomePage() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const createConversation = useMutation(api.contracts.index.createConversation)
  const createAnnexConversation = useMutation(api.annexes.index.createAnnexConversation)
  const createOtherDocumentsConversation = useMutation(
    api.other_documents.index.createOtherDocumentsConversation,
  )

  const handleDokumentiClick = async () => {
    const { conversationId } = await createConversation({})
    navigate({ to: '/contracts/$id', params: { id: conversationId } })
  }

  const handleAneksiClick = async () => {
    const { conversationId } = await createAnnexConversation({})
    navigate({ to: '/annexes/$id', params: { id: conversationId } })
  }

  const handleOstaliDokumentiClick = async () => {
    const { conversationId } = await createOtherDocumentsConversation({})
    navigate({ to: '/other-documents/$id', params: { id: conversationId } })
  }

  return (
    <div className="h-screen flex flex-col bg-white text-gray-900 overflow-hidden">
      <main className="flex-1 flex flex-col items-center justify-center text-center gap-2">
        <h2 className="text-xl font-semibold tracking-tight text-neutral-900">
          Pozdravljeni{user?.firstName ? ` ${user.firstName}` : ``}
        </h2>
        <p className="text-sm text-neutral-600">Pripravljeni na delo? Kako vam lahko pomagam?</p>
        <div className="flex flex-col items-center gap-2 mt-4">
          <div className="flex flex-wrap justify-center gap-2">
            <Button
              type="button"
              variant="outline"
              className="w-fit whitespace-nowrap has-[>svg]:px-4 py-4.5"
              onClick={handleDokumentiClick}
            >
              <FileText className="size-4 text-blue-500" />
              Ustvari pogodbo
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-fit whitespace-nowrap has-[>svg]:px-4 py-4.5"
              onClick={handleAneksiClick}
            >
              <FileText className="size-4 text-purple-500" />
              Aneksi
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-fit whitespace-nowrap has-[>svg]:px-4 py-4.5"
              onClick={handleOstaliDokumentiClick}
            >
              <Files className="size-4 text-green-500" />
              Ostali dokumenti
            </Button>
          </div>
          <div className="flex items-center gap-2">
            <Button
              type="button"
              variant="outline"
              className="w-fit whitespace-nowrap has-[>svg]:px-4 py-4.5"
              onClick={() => navigate({ to: '/dashboard' })}
            >
              <LayoutDashboard className="size-4 text-orange-500" />
              Nadzorna plošča
            </Button>
            <Popover>
              <PopoverTrigger asChild>
                <Button type="button" variant="outline" className="h-auto py-2.5 px-2.5">
                  <Ellipsis className="size-4" />
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-fit p-1" align="start">
                <Button
                  type="button"
                  variant="ghost"
                  className="w-full justify-start text-sm"
                  onClick={() => navigate({ to: '/settings' })}
                >
                  <Settings className="size-4" />
                  Nastavitve
                </Button>
              </PopoverContent>
            </Popover>
          </div>
        </div>
      </main>
      <LogoutButton />
    </div>
  )
}
